
export const makeTypenameNonEnumerable = (data: any) => {
    // If it's an array of objects, handle it here
    if (Array.isArray(data)) {
      return data.map(item => {
        const newItem = { ...item }; // Create a shallow copy
        if (newItem.__typename) {
          delete newItem.__typename; // Remove __typename from the copy
        }
        // You can add any other modifications here
        return newItem;
      });
    }

    // Handle object data (not an array)
    if (data && data.__typename) {
      const { __typename, ...rest } = data; // Destructure and remove __typename
      return rest; // Return the new object without __typename
    }
    return data;
  };
